import { render, staticRenderFns } from "./PriceMenu.vue?vue&type=template&id=5e77f3c0"
import script from "./PriceMenu.vue?vue&type=script&lang=js"
export * from "./PriceMenu.vue?vue&type=script&lang=js"
import style0 from "./PriceMenu.vue?vue&type=style&index=0&id=5e77f3c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports